import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">IT Contractor Union</p>
        <h1>Your Partner in IT Contracting Success</h1>
        <p className="lede">
          Join a community dedicated to empowering IT contractors. Access resources, connect with peers, and elevate your career.
        </p>
        <div className="cta-row">
          <a href="/resources" target="_blank">
            Explore Resources
          </a>
          <a href="/join" target="_blank" className="secondary">
            Join the Union
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Find Your Community</h2>
          <p>
            Connect with fellow IT contractors to share insights, opportunities, and support. Together, we thrive.
          </p>
        </article>
        <article>
          <h2>Access Valuable Resources</h2>
          <p>
            From contract templates to industry news, we provide the tools you need to navigate your career with confidence.
          </p>
        </article>
        <article>
          <h2>Stay Informed</h2>
          <p>
            Keep up with the latest trends and best practices in the IT contracting world through our curated content and updates.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;